import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import useCourse from '@/composables/useCourse'
  import useIcons from '@/composables/useIcons'
  import HTMLRenderer from '@/components/common/HTMLRenderer.vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseTrials',
  setup(__props) {

  const { inTrialCourses } = useCourse()
  const { cardEmptyImage } = useIcons()

  const slicedCourses = computed(() => inTrialCourses.value.slice(0, 2))

return { __sfc: true,inTrialCourses, cardEmptyImage, slicedCourses, computed, useCourse, useIcons, HTMLRenderer }
}

})